import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, matchPath, Outlet, useLocation } from 'react-router-dom';
import { Grid, Paper, Tab, Tabs } from '@mui/material';

import { RouterPaths } from '../../router/paths';
import { permissionsCheck } from '../../utils/permission';

export const UsersAndRoles: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const hasPermissionToViewCompanyTypes = permissionsCheck(['READ_COMPANY_TYPES']);
  const hasPermissionToViewCountries = permissionsCheck(['READ_COUNTRIES']);

  // active tab logic
  const tabsPaths = [RouterPaths.Roles, RouterPaths.RoleDetails, RouterPaths.Users];
  const groupedTabsPaths: Partial<Record<RouterPaths, RouterPaths[]>> = {
    [RouterPaths.Roles]: [RouterPaths.Roles, RouterPaths.RoleDetails],
  };

  const activeTab = tabsPaths.find((tabPath) => {
    if (groupedTabsPaths[tabPath]) {
      return groupedTabsPaths[tabPath]?.some((groupPath) => matchPath(groupPath, pathname));
    }
    return matchPath(tabPath, pathname);
  });

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Tabs value={activeTab} variant="scrollable" scrollButtons="auto">
            {hasPermissionToViewCountries && (
              <Tab
                label={t('users-and-roles.tabs.users')}
                component={Link}
                to={RouterPaths.Users}
                value={RouterPaths.Users}
                sx={{ textTransform: 'none' }}
              />
            )}
            {hasPermissionToViewCompanyTypes && (
              <Tab
                label={t('users-and-roles.tabs.roles')}
                component={Link}
                to={RouterPaths.Roles}
                value={RouterPaths.Roles}
                sx={{ textTransform: 'none' }}
              />
            )}
          </Tabs>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </Paper>
      </Grid>
    </>
  );
};
